import axios from 'axios';

export default {
	async getBannersActive(){
		return axios.get('/api/v1/banners/get-list');
	},	
}